import {
    unsetErrorMessageAction,
    setPaymentStatus, setTimerIntervalId, unsetTimerIntervalId
} from '../../_flux/actions/product_mixed_stocks_lightbox_actions';
import ProductMixedStocksStore from '../../_flux/stores/product_mixed_stocks_lightbox_store';
import Order from '../../_flux/stores/models/order';
import PAYMENT_STATUSES from '../../_flux/constants/payment_statuses';
export default function onPayNowClick() {
    return () => {
        unsetErrorMessageAction();
        setPaymentStatus(PAYMENT_STATUSES.WAITING);
        const {order} = ProductMixedStocksStore.getState();
        if (order instanceof Order && typeof order.paymentRedirectUrl !== 'undefined') {
            window.open(order.paymentRedirectUrl, '_blank');
            let start = (new Date()).getTime();
            const cookieName = `${order.orderNumber.toLowerCase()}-payment=`;
            let timerInterval = setInterval(function () {
                setTimerIntervalId(timerInterval);
                let now = (new Date()).getTime();
                if((now - start) / 1000 > 5 * 60) {
                    setPaymentStatus(PAYMENT_STATUSES.PENDING);
                    removeCookie(cookieName);
                    clearInterval(timerInterval);
                    unsetTimerIntervalId();
                }
                let paymentStatus = document.cookie
                    .split('; ')
                    .find(row => row.startsWith(cookieName));
                if (typeof paymentStatus !== 'undefined') {
                    paymentStatus = paymentStatus.split('=')[1];
                    if (paymentStatus === PAYMENT_STATUSES.SUCCESS) {
                        setPaymentStatus(PAYMENT_STATUSES.SUCCESS);
                    } else {
                        setPaymentStatus(PAYMENT_STATUSES.FAILED);
                    }
                    removeCookie(cookieName);
                    clearInterval(timerInterval);
                    unsetTimerIntervalId();
                }
            }, 3000);
        }
    };
}
function removeCookie(cookieName) {
    document.cookie = cookieName + '; Max-Age=-99999999;';
}
